namespace Matrix.Workflow {
    export interface WorkflowQueueRetrieveRequest extends Serenity.RetrieveRequest {
        QueueCode?: string;
    }
}
